import { Command, renderItems } from "novel/extensions"
import suggestionItems from "@/components/designSystem/Discussions/components/RichEditor/suggestionItems.tsx"

export const slashCommand = Command.configure({
  suggestion: {
    items: () => suggestionItems,
    render: renderItems
  }
})
